import { render, staticRenderFns } from "./industryComparison.vue?vue&type=template&id=630e98de&scoped=true&"
import script from "./industryComparison.vue?vue&type=script&lang=js&"
export * from "./industryComparison.vue?vue&type=script&lang=js&"
import style0 from "./industryComparison.vue?vue&type=style&index=0&id=630e98de&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630e98de",
  null
  
)

export default component.exports